import React, { useState } from 'react';
import { PhoneIcon } from '@heroicons/react/24/solid';
import { FaLinkedin, FaGithub, FaEnvelope } from 'react-icons/fa';
import emailjs from 'emailjs-com';

const Contact = () => {
  const [formData, setFormData] = useState({ name: '', email: '', message: '' });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData({ ...formData, [id]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    emailjs.send(
      'service_rmiwihu', // Replace with your EmailJS Service ID
      'template_b4wl5a7', // Replace with your EmailJS Template ID
      {
        from_name: formData.name,
        reply_to: formData.email,
        message: formData.message,
      },
      'jy6szC1-iDts5pEHz' // Replace with your EmailJS User ID
    ).then(() => {
      setSubmitted(true);
    }).catch((error) => {
      console.error('Error sending message:', error);
    });
  };

  return (
    <section id='contact' className="bg-[#8C3061] text-white py-20 flex md:flex-row flex-col items-center justify-evenly">
      <form onSubmit={handleSubmit} className="bg-[#522258] shadow-lg rounded-lg p-6 md:w-[450px] w-[90%] border border-gray-200">
        <h2 className="md:text-2xl text-lg font-semibold text-white mb-4">Send me a message</h2>
        <div className="mb-4">
          <label className="block text-white mb-1 text-sm" htmlFor="name">Name</label>
          <input type="text" id="name" className="w-full text-[#522258] px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#D95F59]" placeholder="Your Name" value={formData.name} onChange={handleChange} required />
        </div>
        <div className="mb-4">
          <label className="block text-white mb-1 text-sm" htmlFor="email">Email</label>
          <input type="email" id="email" className="w-full text-[#522258] px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#D95F59]" placeholder="Your Email" value={formData.email} onChange={handleChange} required />
        </div>
        <div className="mb-6">
          <label className="block text-white mb-1 text-sm" htmlFor="message">Message</label>
          <textarea id="message" className="w-full text-[#522258] px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#D95F59]" rows="4" placeholder="Your Message" value={formData.message} onChange={handleChange} required></textarea>
        </div>
        <button type="submit" className="w-full bg-[#D95F59] text-white py-2 rounded-lg hover:bg-[#95423e] transition duration-200" disabled={submitted}>
          {submitted ? 'Message Sent!' : 'Send Message'}
        </button>
      </form>
      
      {/* Contact Information */}
      <div className='text-center md:pt-0 pt-14'>
        <h1 className="md:text-3xl text-xl font-extrabold mb-8">Contact Me</h1>
        <p className="md:text-xl text-lg italic text-white mb-12">"Let's create wonders together"</p>
        <div className='flex flex-col space-y-4'>
          <a href="https://www.linkedin.com/in/s-malaiappan/" target="_blank" rel="noopener noreferrer" className="flex items-center space-x-2 hover:underline">
            <FaLinkedin />
            <span>LinkedIn</span>
          </a>
          <a href="https://github.com/Malaiappan59" target="_blank" rel="noopener noreferrer" className="flex items-center space-x-2 hover:underline">
            <FaGithub />
            <span>GitHub</span>
          </a>
          <a href="https://www.youtube.com/@timetravelwithbookart" target="_blank" rel="noopener noreferrer" className="flex items-center space-x-2 hover:underline">
            <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M8 5v14l11-7z"></path>
            </svg>
            <span>YouTube</span>
          </a>
          <a href="mailto:malaiappan59@gmail.com" target="_blank" rel="noopener noreferrer" className="flex items-center space-x-2 hover:underline">
            <FaEnvelope />
            <span>Email: malaiappan59@gmail.com</span>
          </a>
          <p className="flex items-center text-white">
            <PhoneIcon className="w-5 h-5 mr-2" /> Phone: +91 9384752795
          </p>
        </div>
      </div>
    </section>
  );
};

export default Contact;
